import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // 👈 Agregamos useNavigate
import { 
  BookOpen, 
  FileSignature, 
  PieChart, 
  Briefcase, 
  Handshake, 
  FileText, 
  Building, 
  Scale, 
  ScrollText, 
  ChevronRight 
} from 'lucide-react';
import '../styles/stylesGobierno.css';

const Gobierno = () => {
  const { hash } = useLocation();
  const navigate = useNavigate(); // 👈 Inicializamos el hook
  
  const [activeTab, setActiveTab] = useState('informacion');

  useEffect(() => {
    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) elem.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  const periodos = [
    "2017 - 2019",
    "2019 - 2021",
    "2021 - 2023",
    "2023 - 2025",
    "2025 - 2027"
  ];

  // 🔥 Le agregamos la propiedad "ruta" o "link" a cada tarjeta
  const infoPublicaCards = [
    { titulo: "Boletín Oficial", icon: <BookOpen size={28} />, link: "https://www.santafe.gob.ar/boletinoficial/" },
    { titulo: "Resoluciones", icon: <FileSignature size={28} />, ruta: "/resoluciones" },
    { titulo: "Información Presupuestaria", icon: <PieChart size={28} />, ruta: "/presupuestos" },
    { titulo: "Compras y Contrataciones", icon: <Briefcase size={28} />, ruta: "/compras" },
    { titulo: "Convenios", icon: <Handshake size={28} />, ruta: "/convenios" },
    { titulo: "Disposiciones", icon: <FileText size={28} />, ruta: "/disposiciones" },
    { titulo: "Licitaciones", icon: <Building size={28} />, ruta: "/licitaciones" }
  ];

  // Función manejadora de clicks
  const handleCardClick = (item) => {
    if (item.link) {
      // Si tiene link externo (Boletín oficial), abre en nueva pestaña
      window.open(item.link, '_blank');
    } else if (item.ruta) {
      // Si tiene ruta interna, navega usando react-router
      navigate(item.ruta);
    }
  };

  return (
      <div className="Gob">
        <div className="gob__wrap">
          
          <div className="gob__tabs-container">
            <div className="gob__tabs">
              <button 
                className={`gob__tab-btn ${activeTab === 'informacion' ? 'active' : ''}`}
                onClick={() => setActiveTab('informacion')}
              >
                Información Pública
              </button>
              <button 
                className={`gob__tab-btn ${activeTab === 'autoridades' ? 'active' : ''}`}
                onClick={() => setActiveTab('autoridades')}
              >
                Autoridades
              </button>
              <button 
                className={`gob__tab-btn ${activeTab === 'normativas' ? 'active' : ''}`}
                onClick={() => setActiveTab('normativas')}
              >
                Normativas
              </button>
            </div>
          </div>

          <div className="gob__content">

            {activeTab === 'informacion' && (
              <div className="gob__grid">
                {infoPublicaCards.map((item, index) => (
                  <div 
                    key={index} 
                    className="gob__card" 
                    onClick={() => handleCardClick(item)} // 👈 Se llama a la función
                  >
                    <div className="gob__card-icon">
                      {item.icon}
                    </div>
                    <div className="gob__card-body">
                      <h3>{item.titulo}</h3>
                    </div>
                    <ChevronRight className="gob__card-arrow" size={24} />
                  </div>
                ))}
              </div>
            )}

            {activeTab === 'autoridades' && (
              <section className="presidencia" id="presidencia">
                {/* ... tu código intacto de presidencia ... */}
                <div className="presidencia__container">
                  <div className="presidencia__card">
                    <div className="presidencia__image-container">
                      <img src="/resources/fotoPresidencia.jpeg" alt="Patricia Mónica Arber" className="presidencia__foto"/>
                    </div>
                    <div className="presidencia__content">
                      <h4 className="presidencia__cargo">Presidente Comunal</h4>
                      <h3 className="presidencia__nombre">Patricia Mónica Arber</h3>
                      <div className="presidencia__periodos-container">
                        <p className="presidencia__periodo-label">Gestiones:</p>
                        <ul className="presidencia__lista-fechas">
                          {periodos.map((periodo, index) => (
                              <li key={index} className="fecha-chip">{periodo}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            {activeTab === 'normativas' && (
              <div className="gob__grid">
                
                {/* Tarjeta Constituciones (Esta puedes enlazarla luego a donde quieras) */}
                <div 
                  className="gob__card" 
                  onClick={() => navigate('/constituciones')}
                >
                  <div className="gob__card-icon">
                    <Scale size={28} />
                  </div>
                  <div className="gob__card-body">
                    <h3>Constituciones</h3>
                    <div className="gob__tags">
                      <span className="gob__tag">Nacional</span>
                      <span className="gob__tag">Provincial</span>
                      <span className="gob__tag">Orgánica</span>
                    </div>
                  </div>
                  <ChevronRight className="gob__card-arrow" size={24} />
                </div>

                {/* Tarjeta Ordenanzas */}
                <div 
                  className="gob__card" 
                  onClick={() => navigate('/ordenanzas')} // 👈 Navega a Ordenanzas
                >
                  <div className="gob__card-icon">
                    <ScrollText size={28} />
                  </div>
                  <div className="gob__card-body">
                    <h3>Ordenanzas</h3>
                  </div>
                  <ChevronRight className="gob__card-arrow" size={24} />
                </div>
                
              </div>
            )}

          </div>
        </div>
      </div>
  );
}

export default Gobierno;